import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTrophy,
    faMedal,
    faUserPlus,
    faTicket,
    faFire,
    faVideo,
    faBolt,
    faLink,
    faBookmark,
    faBell,
    faComments,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';

/** Mỗi mục tiện ích có gradient và icon riêng */
const UTIL_ITEMS = [
    {
        to: 'top_cash_back',
        icon: faTrophy,
        label: 'Đua top hoàn tiền',
        gradient: 'from-yellow-400 to-amber-500',
        shadow: '_shadow-amber-200',
    },
    {
        to: '/top_orders',
        icon: faMedal,
        label: 'Đua top đơn hàng',
        gradient: 'from-blue-400 to-indigo-500',
        shadow: '_shadow-indigo-200',
    },
    {
        to: '/user-info/ref',
        icon: faUserPlus,
        label: 'Giới thiệu bạn mới',
        gradient: 'from-green-400 to-emerald-500',
        shadow: '_shadow-emerald-200',
    },
    {
        to: '/voucher',
        icon: faTicket,
        label: 'Đổi Voucher',
        gradient: 'from-purple-400 to-violet-600',
        shadow: '_shadow-violet-200',
    },
    {
        to: '/trending',
        icon: faFire,
        label: 'Xu hướng',
        gradient: 'from-orange-400 to-red-500',
        shadow: '_shadow-red-200',
    },
    {
        to: '/cong-dong',
        icon: faComments,
        label: 'Cộng đồng',
        gradient: 'from-fuchsia-400 to-purple-600',
        shadow: '_shadow-purple-200',
    },
    {
        to: '/saved-products',
        icon: faBookmark,
        label: 'Đã lưu',
        gradient: 'from-sky-400 to-cyan-500',
        shadow: '_shadow-cyan-200',
    },
    {
        to: '/price-watch',
        icon: faBell,
        label: 'Theo dõi giá',
        gradient: 'from-teal-400 to-green-500',
        shadow: '_shadow-green-200',
    },
    {
        to: '/post/videolist',
        icon: faVideo,
        label: 'Video độc quyền',
        gradient: 'from-pink-400 to-rose-500',
        shadow: '_shadow-rose-200',
    },
];

function UtilIcon({ gradient, shadow, icon }) {
    return (
        <div className={`bg-gradient-to-br ${gradient} w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center _shadow-lg ${shadow}`}>
            <FontAwesomeIcon icon={icon} className="text-white text-2xl md:text-3xl drop-shadow" />
        </div>
    );
}

function Favorites() {
    const { isLogined, userInfo } = useSelector((state) => state.auth);

    const dealHref = isLogined && userInfo?.userId
        ? `https://sansale.longhousee.net/deal.html?user_id=${userInfo.userId}`
        : 'https://sansale.longhousee.net/deal.html';

    const shopeeFbHref = isLogined && userInfo?.userId
        ? `https://fb.longhousee.me/?user_id=${userInfo.userId}`
        : 'https://fb.longhousee.me/';

    return (
        <div className="bg-surface px-3 pt-3 pb-4 flex flex-col gap-3">
            <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center shadow-sm">
                    <FontAwesomeIcon icon={faBolt} className="text-white text-sm" />
                </div>
                <span className="font-bold text-base">DANH MỤC TIỆN ÍCH</span>
            </div>

            <div className="grid grid-cols-4 gap-x-2 gap-y-4">
                {/* Static items từ config */}
                {UTIL_ITEMS.map((item) => (
                    <Link
                        key={item.to}
                        to={item.to}
                        className="flex flex-col items-center gap-2.5 text-center"
                    >
                        <UtilIcon gradient={item.gradient} shadow={item.shadow} icon={item.icon} />
                        <span className="text-[11px] md:text-xs font-semibold text-content-2 leading-tight line-clamp-2">
                            {item.label}
                        </span>
                    </Link>
                ))}

                {/* Deal 1k, 9k — external link */}
                <a
                    href={dealHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center gap-2.5 text-center"
                >
                    <UtilIcon gradient="from-yellow-300 to-orange-400" shadow="shadow-orange-200" icon={faBolt} />
                    <span className="text-[11px] md:text-xs font-semibold text-content-2 leading-tight">Deal 1k, 9k</span>
                </a>

                {/* Shopee x FB — external link */}
                <a
                    href={shopeeFbHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex flex-col items-center gap-2.5 text-center"
                >
                    <UtilIcon gradient="from-blue-500 to-blue-700" shadow="shadow-blue-200" icon={faFacebook} />
                    <span className="text-[11px] md:text-xs font-semibold text-content-2 leading-tight">Shopee x FB</span>
                </a>

                {/* Đổi Link — internal page */}
                <Link
                    to="/link-converter"
                    className="flex flex-col items-center gap-2.5 text-center"
                >
                    <UtilIcon gradient="from-indigo-500 to-purple-600" shadow="shadow-purple-200" icon={faLink} />
                    <span className="text-[11px] md:text-xs font-semibold text-content-2 leading-tight">Rải link lụm tiền</span>
                </Link>
            </div>
        </div>
    );
}

export default Favorites;
